<template>
  <div class="restaurant-container">
    <v-card class="restaurant">
      <v-toolbar
        color="#E72480"
        dark
      >

        <v-toolbar-title style="font-weight: bold;font-size: 2rem">رستوران</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="addDialog" >
          <v-icon>mdi-plus-thick  </v-icon>
        </v-btn>
      </v-toolbar>
      <div class="empty-array" v-if="originalRestaurant.length===0">اطلاعاتی برای نشان دادن نداریم.</div>
      <div class="empty-array" v-if="originalRestaurant.length===0">لطفا اطلاعات جدید را وارد کنید.</div>
      <div  class="child-offer">
        <v-card
          v-for="item in originalRestaurant"
          width="344"
          style="margin: 20px auto"
        >
          <div class="image">
            <v-img
              lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU"
              :src="item.file ? baseUrl+item.file + '?'+ dates : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU'"
              height="250px"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div class="icons">
              <v-btn :loading="loadingDelete" style="background-color: white" @click="deleteData(item.id)" icon>
                <v-icon color="red">mdi-delete  </v-icon>
              </v-btn>
              <v-btn @click="editData(item.plate,item.phoneNo,item.logoPath,item.name, item.floor,item.id,item.file,item.category)" style="background-color: white" icon>
                <v-icon color="blue" >mdi-pencil  </v-icon>
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text>
            <v-row >
              <v-col cols="12" md="6">
                <v-row style="align-items: center" class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">لوگو:</div>
                  <v-img lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" style="margin-right: 20px" width="80" :src="item.logoPath? baseUrl+item.logoPath + '?'+ dates:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU'">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row style="align-items: center"  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">اسم:</div>
                  <div>{{item.name}}</div>
                </v-row>
              </v-col>

            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">موقعیت:</div>
                  <div>{{item.floor}}</div>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">شماره تلفن:</div>
                  <div>{{item.phoneNo}}</div>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">پلاک:</div>
                  <div>{{item.plate}}</div>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row style="align-items: center" class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">اینستاگرام:</div>
                  <div>{{item.category}}</div>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="800"
      class="dialogs"
      v-on:click:outside="eybiyokh"
    >
      <v-card style="background-color: #d2d2d2;padding: 40px">

        <v-form validation v-model="valid">
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="nameRestaurant"
                :rules="[nameRestaurantRules]"
                label="اسم رستوران"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="9"
            >
              <v-file-input
                v-model="logoFile"
                label="لوگو رستوران را وارد کنید"
                class="input"
                chips
                placeholder=""
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                v-on:change="showLogo($event)"
                v-on:click:clear="deleteLogo"
                required
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="telephoneNumber"
                :rules="[numberRules]"
                :counter="11"
                label="شماره تلفن"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="plateNumber"
                :rules="[plateRules]"
                label="پلاک واحد"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="instagram"
                :rules="[instagramRules]"
                label="اینستاگرام"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              class="select-floor"
            >
              <v-select
                style="flex-direction: column-reverse"
                :items="items"
                label="موقعیت ساختمان"
                solo
                v-model="floor"
                required
                :rules="[floorRules]"
              ></v-select>
            </v-col>
          </v-row>

          <v-col >
            <v-row style="direction:ltr;margin-bottom: 2rem">
              <v-file-input
                v-model="files"
                class="input"
                chips
                placeholder=""
                :rules="rules1"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                v-on:change="showImage($event)"
                v-on:click:clear="deleteImage"
                required
                hide-details
              ></v-file-input>
              <div style="display: flex;justify-content: center;align-items: center;" class="text">عکس مورد نظر خود را اپلود کنید</div>
            </v-row>
            <v-row>
               <v-col>
                 <p style="margin-left: 10px">تصویر رستوران</p>
                 <v-img width="300" height="200"  class="image-test"  :src="image" alt=""></v-img>
               </v-col>
              <v-col>
                <p style="margin-left: 10px">تصویر لگو</p>
                <v-img width="50" height="50"  class="image-test"  :src="logo" alt=""></v-img>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: 50px">

            </v-row>

          </v-col>


        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="eybiyokh()"
          >
            بیخیال
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            @click="sendData"
            :loading="sendLoading"
            v-show="!isEdit"
            :disabled="!valid"
          >
            انجام شد
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            :loading="editLoading"
            @click="recordData"
            v-show="isEdit"
            :disabled="!valid"
          >
            ویرایش کنید.
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  import {toBase64} from "../../../../plugins/toBase64";
  import {deleteRestaurant, putRestaurant, setRestaurant} from "../../../../api/features/restaurant";
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "restaurant",
    data:()=>({
      dialog:false,
      isEdit:false,
      id:0,
      text:'',
      files:[],
      fileCheck:true,
      textCheck:true,
      editLoading:false,
      sendLoading:false,
      loadingDelete:false,
      check:true,
      valid:true,
      rules1: [],
      telephoneNumber: '',
      image:'',
      instagram:'',
      mortgageCost:0,
      nameRestaurant:'',
      logoFile:[],
      logo:'',
      areaNumber:0,
      categories:'',
      plateNumber:"",
      dates:'',
      floor:'',
      baseUrl:'',
      items: [ 'طبقه دوم' ,'طبقه سوم_۱', 'طبقه سوم_۲','طبقه اول','طبقه دوم','طبقه منفی ۱','طبقه همکف'],
      numberRules: v  => {
        if( /^\d+$/.test(v)){
          if(v.length===11)
          {
            return true
          }
          return 'شماره موبایل باید ۱۱ رقم باشد.'
        }
        else{
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },

      nameRestaurantRules:v =>{
        if(v && v.length <=30){
          return true
        }
        else{
          return 'متن وارد شده باید کمتر از ۳۰ کاراکتر باشد';
        }
      },

      plateRules: v =>{
        if( /^\d+$/.test(v)){
          return true
        }
        else
        {
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },
      floorRules: v =>{
        if(v!=='' && v!==undefined)
        {
          return true
        }
        else
        {
          return 'طبقه واحد خود را وارد کنید.'
        }
      },
      instagramRules:v =>{
        if(v && v.length <=30){
          return true
        }
        else{
          return 'متن وارد شده باید کمتر از 30 کاراکتر باشد';
        }
      },


    }),
    methods:{
      showImage(e){
        if(e) {
          this.image = URL.createObjectURL(e)
        }
      },
      showLogo(e){
        if(e) {
          this.logo = URL.createObjectURL(e)
        }
      },
      deleteImage()
      {
        this.image = ''

      },
      deleteLogo(){
        this.logo = ''
      },
      addDialog () {
        this.isEdit = false
        this.dialog = true
        this.image = ''
        this.logo = ''
      },
      async sendData(){
           this.sendLoading = true
           let bb =await toBase64(this.logoFile)
           let pp =await toBase64(this.files)
            try{
               await setRestaurant({
                name:this.nameRestaurant,
                logoPath:bb,
                phoneNo:this.telephoneNumber,
                category:this.instagram,
                floor:this.floor,
                plate:this.plateNumber,
                file:pp,
              }).then(()=>{
                 this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
               }).catch(()=>{
                 this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})

               })
            }catch (e) {
            }
        await  this.getRestaurantReq()
        this.dialog = false
        this.files=[]
        this.logoFile=[]
        this.nameRestaurant = ''
        this.telephoneNumber = ''
        this.floor = ''
        this.plateNumber = ''
        this.image = ''
        this.logo=''
        this.instagram=''
        this.sendLoading = false
      },
      async recordData(){
        this.editLoading = true
        try {
             let bb=await toBase64(this.files)
             let cc =await toBase64(this.logoFile)
               let pa =
               {
                 id: this.id,
                 name:this.nameRestaurant,
                 logoPath:cc,
                 phoneNo:this.telephoneNumber,
                 floor:this.floor,
                 plate:this.plateNumber,
                 category: this.instagram,
                 file:bb,
               }
               await putRestaurant(pa, this.id).then(() => {
                  this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
               }).catch(()=>{
                 this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
               })
        }catch(e){
        }
        await   this.getRestaurantReq()
        this.dates = new Date()
        this.editLoading = false
        this.dialog = false
        this.files=[]
        this.logoFile=[]
        this.nameRestaurant = ''
        this.telephoneNumber = ''
        this.floor = ''
        this.plateNumber = ''
        this.image = ''
        this.logo=''
        this.instagram = ''
      },
      eybiyokh(){
        this.dialog = false
        this.files=[]
        this.logoFile=[]
        this.nameRestaurant = ''
        this.telephoneNumber = ''
        this.floor = ''
        this.plateNumber = ''
        this.image = ''
        this.logo =''
        this.instagram = ''
      },
     async deleteData(id){
        try {
          let yes = confirm("مطمئنی میخوای پاک کنی!");
          if (yes) {
            this.loadingDelete = true
            await deleteRestaurant(id).then(() => {
              this.getRestaurantReq()
            })
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات حذف شدن اعمال شد.', showSnackbar:true})
          }
        }catch (e) {
          this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
        }
        this.loadingDelete = false

      },
      editData(plate,phoneNo,logoPath,nameRestaurant,floor,id,imgPath,instagram){
        this.files = []
        this.logoFile = []
        this.nameRestaurant = nameRestaurant
        this.logo = this.baseUrl+logoPath+'?'+this.dates
        this.telephoneNumber = phoneNo
        this.floor = floor
        this.plateNumber = plate
        this.id=id
        this.instagram = instagram
        this.dialog = true
        this.isEdit = true
        this.image  = this.baseUrl+imgPath+'?'+this.dates;
      },
      ...mapActions({
        getRestaurantReq:'restaurantStore/fetchRestaurant',
        snackBarAction:'snackBar/snackBarAction'
      }),
    },
    computed: {
      ...mapGetters({
        originalRestaurant: 'restaurantStore/get_restaurant',
      })
    },
    async mounted() {
      this.$emit('restaurant-toggle', false)
      this.baseUrl = process.env.VUE_APP_BASE_URL
      await this.getRestaurantReq()
      this.$emit('restaurant-toggle', true)

    },
  }
</script>
<style>



</style>
<style scoped>
  .dialogs .row{
    align-items: center;
    justify-content: center;
  }
  .restaurant{
    width: 85%;
    margin: 0 auto;
  }
  .restaurant .row{
    justify-content: flex-start;
    align-items: center;
    margin: 0.3rem -7px;
  }
  .flex-direction{
    display: flex;
    flex-direction: row;
  }

  .child-offer{
    padding: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
  }

  .input{
    direction: ltr;
  }

  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }

  .link-input{
    width: 40%;
  }
  .image{
    position:  relative;
  }
  .icons{
    position: absolute;
    top: 0;
    left: 0;
  }
  .empty-array{
    font-size: 2rem;
    margin-right: 3rem;
    font-weight: bold;
  }
  p{
    margin-right: 5px;
  }
</style>
